/* Deniz Doğal Taş — Test Motoru
 * Shopify tema varlığı. Sayfa şablonu window.DENIZ_TEST_ID ve window.DENIZ_VERI
 * değişkenlerini kurar, bu dosya akışı yönetir.
 *
 * Akış: giriş → kimlik bilgileri → sorular → hesaplama → sonuç → ürünler → sepet
 */
(function () {
  "use strict";

  var K = {
    kok: null,          // kök DOM elemanı
    test: null,         // aktif test tanımı
    adim: 0,            // soru indeksi
    girdi: {},          // ad, doğum tarihi vb.
    cevaplar: [],       // soru yanıtları
    sonuc: null,
  };

  /* ---------- yardımcılar ---------- */

  function el(etiket, sinif, icerik) {
    var d = document.createElement(etiket);
    if (sinif) d.className = sinif;
    if (icerik != null) d.innerHTML = icerik;
    return d;
  }

  function temizle(n) { while (n.firstChild) n.removeChild(n.firstChild); }

  function paraBirimi(kurus) {
    return new Intl.NumberFormat("tr-TR", {
      style: "currency", currency: "TRY", maximumFractionDigits: 0,
    }).format(kurus);
  }

  // Kullanıcı metnini DOM'a basmadan önce kaçırır — girdi doğrudan ekrana yazılıyor
  function kacir(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  }

  // style özniteliğine yalnızca bilinen biçimde renk yazılmasına izin verir.
  // Değer veri dosyalarından gelse de stil enjeksiyonuna kapı bırakmıyoruz.
  function guvenliRenk(r) {
    return /^(#[0-9a-fA-F]{3,8}|var\(--[a-zA-Z0-9-]+\)|[a-zA-Z]{3,20})$/.test(String(r || ""))
      ? String(r) : "var(--dz-mor)";
  }

  // Kapak videosu ağır bir varlık; yalnızca uygun koşullarda yüklenir.
  function videoAcilsinMi() {
    if (window.innerWidth < 900) return false;                       // mobilde veri harcamayalım
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return false;
    var b = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (b) {
      if (b.saveData) return false;                                  // veri tasarrufu açıksa hiç yükleme
      if (/^(slow-2g|2g|3g)$/.test(b.effectiveType || "")) return false;
    }
    return true;
  }

  function gecisYap(yeni) {
    var g = K.kok.querySelector(".dz-sahne");
    // Eski ekrandaki odağı bırak; yoksa yeni ekranda aynı konumdaki öğe
    // odaklanmış görünür ve önceki seçim duruyormuş gibi algılanır
    if (document.activeElement && g.contains(document.activeElement)) {
      document.activeElement.blur();
    }
    g.classList.add("dz-cikis");
    setTimeout(function () {
      temizle(g);
      g.appendChild(yeni);
      g.classList.remove("dz-cikis");
      g.classList.add("dz-giris");
      setTimeout(function () { g.classList.remove("dz-giris"); }, 600);
      var ust = K.kok.getBoundingClientRect().top + window.scrollY - 24;
      if (window.scrollY > ust) window.scrollTo({ top: ust, behavior: "smooth" });
      // Ekran okuyucu ve klavye kullanıcısı için odağı yeni başlığa taşı.
      // preventScroll: sayfa yukarı zıplamasın.
      var odak = yeni.querySelector(".dz-soru, .dz-baslik-orta, .dz-baslik, .dz-sonuc-baslik");
      if (odak) {
        if (!odak.hasAttribute("tabindex")) odak.setAttribute("tabindex", "-1");
        try { odak.focus({ preventScroll: true }); } catch (e) { /* eski tarayıcı */ }
      }
    }, 280);
  }

  function ilerlemeGuncelle(oran) {
    var c = K.kok.querySelector(".dz-ilerleme-dolgu");
    if (c) c.style.width = Math.max(0, Math.min(100, oran * 100)) + "%";
  }

  /* ---------- 1. giriş ekranı ---------- */

  function girisEkrani() {
    var t = K.test;
    var s = el("div", "dz-kart dz-giris-kart");
    // Kapak: statik görsel her zaman yüklenir. Video yalnızca geniş ekranda,
    // veri tasarrufu kapalıysa ve hareket azaltma istenmiyorsa devreye girer.
    var kapak = "";
    if (t.kapak && window.DENIZ_GORSEL_KOK) {
      var gorselUrl = window.DENIZ_GORSEL_KOK + t.kapak;
      // Video adresleri Shopify Files'tan gelir; sözlükte yoksa video atlanır
      var videoUrl = (t.video && window.DENIZ_VIDEO && window.DENIZ_VIDEO[t.video]) || null;
      var videoUygun = videoUrl && videoAcilsinMi();
      kapak =
        '<div class="dz-kapak' + (videoUygun ? " dz-kapak-video" : "") + '">' +
          '<img src="' + kacir(gorselUrl) + '" alt="" loading="eager">' +
          (videoUygun
            ? '<video class="dz-kapak-oynatici" src="' + kacir(videoUrl) + '" poster="' + kacir(gorselUrl) + '"' +
              ' autoplay muted loop playsinline preload="none" aria-hidden="true"></video>'
            : "") +
        "</div>";
    }
    s.innerHTML =
      kapak +
      '<div class="dz-rozet">' + kacir(t.ustBaslik || "Deniz Doğal Taş") + "</div>" +
      '<h1 class="dz-baslik">' + kacir(t.ad) + "</h1>" +
      '<p class="dz-ozet">' + kacir(t.ozet) + "</p>" +
      '<ul class="dz-bilgi-satir">' +
        "<li><span>" + (t.sorular ? t.sorular.length : 0) + "</span>Soru</li>" +
        "<li><span>" + kacir(t.sure || "2 dakika") + "</span>Süre</li>" +
        "<li><span>" + kacir(t.ciktiEtiket || "Taş haritası") + "</span>Çıktı</li>" +
        "<li><span>48</span>Taş arşivi</li>" +
      "</ul>" +
      '<button class="dz-btn dz-btn-ana" type="button">Teste Başla</button>' +
      '<p class="dz-kucuk-not">Sonuçlar geleneksel sembolizme dayanır; tıbbi tavsiye değildir.</p>';
    s.querySelector("button").addEventListener("click", girdiEkrani);

    // Video yalnızca ilk karesi hazır olduğunda görünür olur; böylece
    // yüklenirken siyah bir kutu yerine statik kapak durur.
    var oynatici = s.querySelector(".dz-kapak-oynatici");
    if (oynatici) {
      oynatici.addEventListener("loadeddata", function () { oynatici.setAttribute("data-hazir", "1"); });
      oynatici.addEventListener("error", function () { oynatici.remove(); });
      oynatici.preload = "auto";
      var oynat = oynatici.play();
      if (oynat && oynat.catch) oynat.catch(function () { /* otomatik oynatma engellendiyse görsel kalır */ });
    }
    return s;
  }

  /* ---------- 2. kimlik/girdi ekranı ---------- */

  var GIRDI_TANIM = {
    ad:          { etiket: "Adın ve soyadın", tip: "text", ipucu: "Örn. Ayşe Yılmaz", zorunlu: true },
    ad2:         { etiket: "Eşinin / partnerinin adı soyadı", tip: "text", ipucu: "Örn. Mehmet Yılmaz", zorunlu: true },
    anneAdi:     { etiket: "Annenin adı", tip: "text", ipucu: "Yıldızname için gereklidir", zorunlu: true },
    dogumTarihi: { etiket: "Doğum tarihin", tip: "date", zorunlu: true },
    dogumTarihi2:{ etiket: "Eşinin / partnerinin doğum tarihi", tip: "date", zorunlu: true },
    dogumSaati:  { etiket: "Doğum saatin", tip: "time", ipucu: "Bilmiyorsan boş bırak, güneş haritası çıkarılır", zorunlu: false },
    dogumYeri:   { etiket: "Doğum yerin", tip: "text", ipucu: "Örn. İzmir", zorunlu: false },
    cinsiyet:    { etiket: "Cinsiyet", tip: "secim", secenekler: ["Kadın", "Erkek", "Belirtmek istemiyorum"], zorunlu: false },
    kimeHediye:  { etiket: "Hediye kime?", tip: "secim", secenekler: ["Eşim / sevgilim", "Annem", "Babam", "Arkadaşım", "Kardeşim", "Kendim"], zorunlu: true },
    butce:       { etiket: "Bütçen", tip: "secim", secenekler: ["1000 TL altı", "1000 - 2000 TL", "2000 - 3500 TL", "Fark etmez"], zorunlu: false },
  };

  function girdiEkrani() {
    var t = K.test;
    var s = el("div", "dz-kart");
    var alanlar = (t.girdiler || []).map(function (anahtar) {
      var g = GIRDI_TANIM[anahtar];
      if (!g) return "";
      var id = "dz-" + anahtar;
      var giris;
      if (g.tip === "secim") {
        giris = '<select id="' + id + '" data-anahtar="' + anahtar + '">' +
          '<option value="">Seç…</option>' +
          g.secenekler.map(function (o) { return '<option value="' + kacir(o) + '">' + kacir(o) + "</option>"; }).join("") +
          "</select>";
      } else {
        var tip = ["text", "date", "time", "number"].indexOf(g.tip) !== -1 ? g.tip : "text";
        giris = '<input id="' + id + '" data-anahtar="' + kacir(anahtar) + '" type="' + tip + '"' +
          (g.ipucu ? ' placeholder="' + kacir(g.ipucu) + '"' : "") +
          (g.tip === "date" ? ' max="' + new Date().toISOString().slice(0, 10) + '"' : "") + ">";
      }
      return '<label class="dz-alan"><span class="dz-alan-etiket">' + kacir(g.etiket) +
        (g.zorunlu ? '<i class="dz-zorunlu">*</i>' : ' <i class="dz-istege-bagli">isteğe bağlı</i>') +
        "</span>" + giris +
        (g.ipucu && g.tip !== "text" ? '<span class="dz-alan-ipucu">' + kacir(g.ipucu) + "</span>" : "") +
        "</label>";
    }).join("");

    s.innerHTML =
      '<div class="dz-rozet">Adım 1</div>' +
      '<h2 class="dz-baslik-orta">Seni tanıyalım</h2>' +
      '<p class="dz-ozet">Haritanın doğru çıkması için bu bilgiler gerekiyor. Girdiğin hiçbir bilgi sunucuya gönderilmez; hesaplama tamamen kendi tarayıcında yapılır.</p>' +
      '<div class="dz-alanlar">' + alanlar + "</div>" +
      '<p class="dz-hata" hidden></p>' +
      '<button class="dz-btn dz-btn-ana" type="button">Devam</button>';

    s.querySelector("button").addEventListener("click", function () {
      var hata = s.querySelector(".dz-hata");
      var eksik = [];
      K.girdi = {};
      (t.girdiler || []).forEach(function (anahtar) {
        var g = GIRDI_TANIM[anahtar];
        var alan = s.querySelector("#dz-" + anahtar);
        var deger = alan ? alan.value.trim() : "";
        if (g && g.zorunlu && !deger) eksik.push(g.etiket);
        K.girdi[anahtar] = deger;
      });
      if (eksik.length) {
        hata.hidden = false;
        hata.textContent = "Şu alanlar gerekli: " + eksik.join(", ");
        return;
      }
      hata.hidden = true;
      K.adim = 0;
      K.cevaplar = [];
      if (t.sorular && t.sorular.length) soruEkrani();
      else hesaplaVeGoster();
    });

    gecisYap(s);
    ilerlemeGuncelle(0.08);
  }

  /* ---------- 3. soru ekranı ---------- */

  function soruEkrani() {
    var t = K.test;
    var soru = t.sorular[K.adim];
    var s = el("div", "dz-kart dz-soru-kart");

    // Daha önce cevaplanmışsa (geri gelindiyse) o seçenek işaretli gelir
    var oncekiCevap = K.cevaplar[K.adim];
    var oncekiIndeks = oncekiCevap ? soru.secenekler.indexOf(oncekiCevap) : -1;

    s.innerHTML =
      '<div class="dz-rozet">Soru ' + (K.adim + 1) + " / " + t.sorular.length + "</div>" +
      '<h2 class="dz-soru" tabindex="-1">' + kacir(soru.metin) + "</h2>" +
      (soru.aciklama ? '<p class="dz-ozet">' + kacir(soru.aciklama) + "</p>" : "") +
      '<div class="dz-secenekler">' +
        soru.secenekler.map(function (o, i) {
          return '<button class="dz-secenek' + (i === oncekiIndeks ? " dz-secili" : "") + '" type="button" data-i="' + i + '">' +
            '<span class="dz-secenek-isaret"></span>' +
            '<span class="dz-secenek-metin">' + kacir(o.etiket) + "</span>" +
            "</button>";
        }).join("") +
      "</div>" +
      (K.adim > 0 ? '<button class="dz-btn dz-btn-geri" type="button">← Önceki soru</button>' : "");

    Array.prototype.forEach.call(s.querySelectorAll(".dz-secenek"), function (b) {
      b.addEventListener("click", function () {
        Array.prototype.forEach.call(s.querySelectorAll(".dz-secenek"), function (x) { x.classList.remove("dz-secili"); });
        b.classList.add("dz-secili");
        // Tıklanan butondan odağı al: yoksa yeni soruda aynı sıradaki seçenek
        // odak halkasıyla çizilip "önceki cevabım seçili kalmış" izlenimi veriyor
        b.blur();
        var i = Number(b.getAttribute("data-i"));
        K.cevaplar[K.adim] = soru.secenekler[i];
        setTimeout(function () {
          K.adim++;
          if (K.adim < t.sorular.length) soruEkrani();
          else hesaplaVeGoster();
        }, 260);
      });
    });

    var geri = s.querySelector(".dz-btn-geri");
    if (geri) geri.addEventListener("click", function () { K.adim--; soruEkrani(); });

    gecisYap(s);
    ilerlemeGuncelle(0.08 + 0.62 * ((K.adim + 1) / t.sorular.length));
  }

  /* ---------- 4. hesaplama animasyonu ---------- */

  function hesaplaVeGoster() {
    var s = el("div", "dz-kart dz-hesap");
    s.innerHTML =
      '<div class="dz-yildiz-halka"><i></i><i></i><i></i></div>' +
      '<h2 class="dz-baslik-orta">Haritan çıkarılıyor</h2>' +
      '<p class="dz-hesap-satir">Veriler hizalanıyor…</p>';
    gecisYap(s);
    ilerlemeGuncelle(0.82);

    var satirlar = K.test.hesapSatirlari || [
      "Doğum verisi çözümleniyor…",
      "Element dengesi hesaplanıyor…",
      "Taş karşılıkları eşleştiriliyor…",
      "Sonuç hazırlanıyor…",
    ];
    var i = 0;
    var yaz = setInterval(function () {
      var p = s.querySelector(".dz-hesap-satir");
      if (p && satirlar[i]) p.textContent = satirlar[i];
      i++;
      if (i >= satirlar.length) {
        clearInterval(yaz);
        setTimeout(function () {
          try {
            K.sonuc = K.test.sonuc(K.girdi, K.cevaplar, window.DENIZ_VERI);
          } catch (e) {
            console.error("[deniz-test] sonuç hesaplanamadı:", e);
            hataEkrani();
            return;
          }
          sonucEkrani();
        }, 500);
      }
    }, 620);
  }

  function hataEkrani() {
    var s = el("div", "dz-kart");
    s.innerHTML =
      '<h2 class="dz-baslik-orta">Sonuç oluşturulamadı</h2>' +
      '<p class="dz-ozet">Beklenmedik bir durum oluştu. Testi yeniden başlatabilirsin.</p>' +
      '<button class="dz-btn dz-btn-ana" type="button">Yeniden başla</button>';
    s.querySelector("button").addEventListener("click", function () { gecisYap(girisEkrani()); ilerlemeGuncelle(0); });
    gecisYap(s);
  }

  /* ---------- 5. sonuç ekranı ---------- */

  function sonucEkrani() {
    var r = K.sonuc;
    var s = el("div", "dz-kart dz-sonuc");

    var rozetler = (r.rozetler || []).map(function (x) {
      return '<div class="dz-oz-rozet"><span class="dz-oz-etiket">' + kacir(x.etiket) +
        '</span><span class="dz-oz-deger">' + kacir(x.deger) + "</span></div>";
    }).join("");

    var paragraflar = (r.metin || []).map(function (p) {
      return "<p>" + kacir(p) + "</p>";
    }).join("");

    // Sonuç uzun olduğunda başlıklı bölümlere ayrılır — tek blok metin okunmuyor
    var bolumler = (r.bolumler || []).map(function (b) {
      var govde = (b.paragraflar || []).map(function (p) { return "<p>" + kacir(p) + "</p>"; }).join("");
      var vurgu = b.vurgu ? '<blockquote class="dz-vurgu">' + kacir(b.vurgu) + "</blockquote>" : "";
      return '<section class="dz-bolum"><h3 class="dz-bolum-baslik">' + kacir(b.baslik) + "</h3>" +
        vurgu + '<div class="dz-metin">' + govde + "</div></section>";
    }).join("");

    // Her taşın neden önerildiğini tek tek açıklar
    var gerekceler = (r.gerekceler || []).map(function (g, i) {
      return '<div class="dz-gerekce" style="animation-delay:' + (i * 80) + 'ms">' +
        '<span class="dz-gerekce-nokta" style="background:' + guvenliRenk(g.renk) + ";color:" + guvenliRenk(g.renk) + '"></span>' +
        "<span><b class=\"dz-gerekce-ad\">" + kacir(g.ad) + "</b>" +
        '<span class="dz-gerekce-metin">' + kacir(g.metin) + "</span></span></div>";
    }).join("");

    var uyari = r.golge
      ? '<div class="dz-uyari"><b>' + kacir(r.golge.baslik || "Dikkat edilecek taraf") + "</b>" +
        "<span>" + kacir(r.golge.metin) + "</span></div>"
      : "";

    var olcumler = (r.olcumler || []).map(function (o) {
      return '<div class="dz-olcum">' +
        '<div class="dz-olcum-ust"><span>' + kacir(o.ad) + "</span><b>%" + Math.round(o.oran * 100) + "</b></div>" +
        '<div class="dz-olcum-cubuk"><i style="width:' + Math.round(o.oran * 100) + "%;background:" + guvenliRenk(o.renk) + '"></i></div>' +
        "</div>";
    }).join("");

    s.innerHTML =
      '<div class="dz-rozet dz-rozet-sonuc">Sonucun hazır</div>' +
      (r.ustBaslik ? '<p class="dz-sonuc-ust">' + kacir(r.ustBaslik) + "</p>" : "") +
      // Simge gradyanın DIŞINDA duruyor: background-clip:text + color:transparent,
      // emoji olarak çizilen burç sembolünü beyaz kutuya çeviriyordu.
      (r.simge ? '<div class="dz-simge">' + kacir(r.simge) + "</div>" : "") +
      '<h1 class="dz-sonuc-baslik">' + kacir(r.baslik) + "</h1>" +
      (r.altBaslik ? '<p class="dz-sonuc-alt">' + kacir(r.altBaslik) + "</p>" : "") +
      (rozetler ? '<div class="dz-oz-rozetler">' + rozetler + "</div>" : "") +
      (r.vurgu ? '<blockquote class="dz-vurgu">' + kacir(r.vurgu) + "</blockquote>" : "") +
      '<div class="dz-metin">' + paragraflar + "</div>" +
      bolumler +
      (olcumler ? '<section class="dz-bolum"><h3 class="dz-bolum-baslik">Denge tablon</h3><div class="dz-olcumler">' + olcumler + "</div></section>" : "") +
      uyari +
      (gerekceler ? '<section class="dz-bolum"><h3 class="dz-bolum-baslik">Taşların neden bunlar</h3><div class="dz-gerekceler">' + gerekceler + "</div></section>" : "") +
      '<div class="dz-kod-alani"></div>' +
      '<div class="dz-urun-bolum">' +
        '<h3 class="dz-bolum-baslik">Sana eşleşen ürünler</h3>' +
        '<p class="dz-ozet">' + kacir(r.urunGiris || "Sonucuna göre seçilen, stoklu ürünler:") + "</p>" +
        '<div class="dz-urunler"></div>' +
      "</div>" +
      '<div class="dz-sonuc-aksiyon">' +
        '<button class="dz-btn dz-btn-ikincil dz-tekrar" type="button">Testi tekrarla</button>' +
        '<a class="dz-btn dz-btn-ikincil" href="/collections/all">Tüm koleksiyon</a>' +
      "</div>";

    s.querySelector(".dz-tekrar").addEventListener("click", function () {
      K.adim = 0; K.cevaplar = []; K.girdi = {};
      gecisYap(girisEkrani()); ilerlemeGuncelle(0);
    });

    gecisYap(s);
    ilerlemeGuncelle(1);
    setTimeout(function () {
      urunleriBas(s.querySelector(".dz-urunler"), r.taslar || []);
      indirimKoduGetir(s.querySelector(".dz-kod-alani"));
    }, 340);
  }

  /* ---------- kişiye özel indirim kodu ---------- */

  // Kod, Shopify Admin API ile üretilir; bu yalnızca sunucuda yapılabilir.
  // Tarayıcı yalnızca adı gönderir, karşılığında hazır kodu alır.
  function indirimKoduGetir(kap) {
    if (!kap) return;
    var api = window.DENIZ_KOD_API;
    var ad = K.girdi && (K.girdi.ad || K.girdi.ad2);
    if (!api || !ad) return; // servis tanımlı değilse bölüm hiç görünmez

    kap.innerHTML =
      '<div class="dz-kod dz-kod-bekliyor">' +
        '<div class="dz-kod-ust">Sana özel indirim hazırlanıyor…</div>' +
      "</div>";

    var zamanAsimi = setTimeout(function () { kap.innerHTML = ""; }, 12000);

    fetch(api, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ad: ad }),
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error("servis " + r.status)); })
      .then(function (d) {
        clearTimeout(zamanAsimi);
        if (!d || !d.kod) throw new Error("kod yok");
        kodBas(kap, d, Z_ilkAd(ad));
      })
      .catch(function (e) {
        clearTimeout(zamanAsimi);
        // Kod üretilemezse sonuç ekranı bozulmasın; bölüm sessizce kaldırılır
        console.warn("[deniz-test] indirim kodu alınamadı:", e.message);
        kap.innerHTML = "";
      });
  }

  // Ortak dosyadaki ilkAd'ı burada da kullanmak için ince sarmalayıcı
  function Z_ilkAd(t) {
    return (window.DZ && window.DZ.ilkAd) ? window.DZ.ilkAd(t) : String(t || "").split(/\s+/)[0];
  }

  function kodBas(kap, d, ad) {
    kap.innerHTML =
      '<div class="dz-kod">' +
        '<div class="dz-kod-ust">' + kacir(ad) + ", sana özel</div>" +
        '<div class="dz-kod-oran">%' + Number(d.oran || 10) + " indirim</div>" +
        '<button class="dz-kod-kutu" type="button" title="Kopyalamak için tıkla">' +
          '<span class="dz-kod-metin">' + kacir(d.kod) + "</span>" +
          '<span class="dz-kod-kopyala">Kopyala</span>' +
        "</button>" +
        '<div class="dz-kod-sayac" data-biter="' + kacir(d.biter || "") + '"></div>' +
        '<p class="dz-kod-not">Tek kullanımlık. Diğer indirim kodlarıyla birlikte kullanılabilir. ' +
          "Sepette “İndirim kodu” alanına yaz.</p>" +
      "</div>";

    var btn = kap.querySelector(".dz-kod-kutu");
    btn.addEventListener("click", function () {
      var metin = d.kod;
      var bitir = function () {
        var e = btn.querySelector(".dz-kod-kopyala");
        e.textContent = "Kopyalandı ✓";
        btn.classList.add("dz-kod-kopyalandi");
        setTimeout(function () { e.textContent = "Kopyala"; btn.classList.remove("dz-kod-kopyalandi"); }, 2200);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(metin).then(bitir, function () { metniSec(btn); });
      } else metniSec(btn);
    });

    sayacBaslat(kap.querySelector(".dz-kod-sayac"));
  }

  function metniSec(btn) {
    var r = document.createRange();
    r.selectNodeContents(btn.querySelector(".dz-kod-metin"));
    var s = window.getSelection();
    s.removeAllRanges(); s.addRange(r);
  }

  function sayacBaslat(n) {
    if (!n) return;
    var biter = new Date(n.getAttribute("data-biter")).getTime();
    if (!biter) { n.textContent = "24 saat geçerli"; return; }
    function tik() {
      var kalan = biter - Date.now();
      if (kalan <= 0) {
        n.innerHTML = '<b class="dz-kod-bitti">Süresi doldu</b>';
        clearInterval(z);
        return;
      }
      var sa = Math.floor(kalan / 3600000);
      var dk = Math.floor((kalan % 3600000) / 60000);
      var sn = Math.floor((kalan % 60000) / 1000);
      n.innerHTML = "Geçerlilik: <b>" + sa + " saat " + dk + " dakika " + (sa === 0 ? sn + " saniye" : "") + "</b>";
    }
    tik();
    var z = setInterval(tik, 1000);
  }

  /* ---------- 6. ürün kartları + sepet ---------- */

  // Ürün tipini okunabilir bir gruba indirger. Katalogdaki product_type
  // alanı tutarsız yazılmış olabildiği için başlık üzerinden de bakıyoruz.
  // Not: Türkçe ünsüz yumuşaması yüzünden "bileklik" eki alınca "bilekliği"
  // olur ve düz "bileklik" araması eşleşmez. Desenler bunu kapsıyor.
  function grupBul(urun) {
    var m = ((urun.tip || "") + " " + (urun.baslik || "")).toLocaleLowerCase("tr");
    if (/tespih|tesbih|zikirmatik/.test(m)) return "Tespihler";
    if (/kolye|gerdanlık|gerdanlik|pandantif/.test(m)) return "Kolyeler";
    if (/bileklik|bileklığ|bilekliğ|bilezik|bileziğ/.test(m)) return "Bileklikler";
    if (/küpe|kupe/.test(m)) return "Küpeler";
    if (/yüzük|yuzuk|yüzüğ|yuzug/.test(m)) return "Yüzükler";
    if (/halhal/.test(m)) return "Halhallar";
    if (/sarkaç|sarkac|pandül|pandul/.test(m)) return "Sarkaçlar";
    if (/anahtarl|aksesu|çanta|canta|broş|bros/.test(m)) return "Aksesuarlar";
    if (/küre|kure|piramit|ham taş|ham tas|doğal parça|obje|kalp |yumurta|değnek|degnek/.test(m)) return "Objeler";
    if (/set\b|kombin/.test(m)) return "Setler";
    return "Diğer Ürünler";
  }

  // Cilt bakım gibi taş dışı ürünler test sonucuna girmemeli
  function urunUygunMu(urun) {
    var m = ((urun.tip || "") + " " + (urun.baslik || "")).toLocaleLowerCase("tr");
    return !/cilt bakım|cilt bakim|krem|serum|sabun|yağı|yagi|şampuan|sampuan/.test(m);
  }

  var GRUP_SIRA = ["Bileklikler", "Kolyeler", "Tespihler", "Setler", "Küpeler", "Yüzükler", "Halhallar", "Sarkaçlar", "Objeler", "Aksesuarlar", "Diğer Ürünler"];

  // Önerilen taşlardan ürünleri toplayıp tipe göre gruplar.
  // Her taştan sırayla alır ki tek taş listeyi domine etmesin.
  function urunSec(tasAnahtarlari) {
    var veri = (window.DENIZ_VERI && window.DENIZ_VERI.taslar) || {};
    var secilen = [], gorulen = {};
    for (var tur = 0; tur < 12; tur++) {
      for (var i = 0; i < tasAnahtarlari.length; i++) {
        var t = veri[tasAnahtarlari[i]];
        if (!t || !t.urunler || !t.urunler[tur]) continue;
        var u = t.urunler[tur];
        if (gorulen[u.id] || !urunUygunMu(u)) continue;
        gorulen[u.id] = 1;
        secilen.push({ urun: u, tasAd: t.ad, grup: grupBul(u) });
        if (secilen.length >= 48) break;
      }
      if (secilen.length >= 48) break;
    }

    // Gruplara ayır, grup başına en fazla 8 ürün
    var gruplar = {};
    secilen.forEach(function (x) {
      if (!gruplar[x.grup]) gruplar[x.grup] = [];
      if (gruplar[x.grup].length < 8) gruplar[x.grup].push(x);
    });

    // Tek ürünlü grupları "Diğer Ürünler"e katarak dağınıklığı önle
    var toplu = [];
    GRUP_SIRA.forEach(function (g) {
      if (!gruplar[g]) return;
      if (gruplar[g].length < 2 && g !== "Diğer Ürünler") {
        gruplar["Diğer Ürünler"] = (gruplar["Diğer Ürünler"] || []).concat(gruplar[g]);
        return;
      }
      toplu.push({ ad: g, urunler: gruplar[g] });
    });
    if (gruplar["Diğer Ürünler"] && !toplu.some(function (x) { return x.ad === "Diğer Ürünler"; })) {
      toplu.push({ ad: "Diğer Ürünler", urunler: gruplar["Diğer Ürünler"].slice(0, 8) });
    }
    return toplu;
  }

  function urunKarti(x, i) {
    var u = x.urun;
    var gorsel = u.gorsel ? (u.gorsel.indexOf("?") === -1 ? u.gorsel + "?width=600" : u.gorsel + "&width=600") : "";
    return '<article class="dz-urun" style="animation-delay:' + (i * 60) + 'ms">' +
      '<a class="dz-urun-gorsel" href="/products/' + kacir(u.handle) + '">' +
        (gorsel ? '<img src="' + kacir(gorsel) + '" alt="' + kacir(u.baslik) + '" loading="lazy">' : '<span class="dz-gorsel-yok"></span>') +
        '<span class="dz-urun-tas">' + kacir(x.tasAd) + "</span>" +
      "</a>" +
      '<div class="dz-urun-govde">' +
        '<a class="dz-urun-ad" href="/products/' + kacir(u.handle) + '">' + kacir(u.baslik) + "</a>" +
        '<div class="dz-urun-alt">' +
          '<span class="dz-urun-fiyat">' + paraBirimi(u.fiyat) + "</span>" +
          '<button class="dz-btn dz-btn-sepet" type="button" data-varyant="' + Number(u.varyant) + '">Sepete Ekle</button>' +
        "</div>" +
      "</div>" +
    "</article>";
  }

  function urunleriBas(kap, tasAnahtarlari) {
    if (!kap) return;
    var gruplar = urunSec(tasAnahtarlari);
    if (!gruplar.length) {
      kap.innerHTML = '<p class="dz-ozet">Şu an bu taşlar için stokta ürün görünmüyor. ' +
        '<a href="/collections/all">Koleksiyonun tamamına</a> göz atabilirsin.</p>';
      return;
    }
    var toplam = gruplar.reduce(function (a, g) { return a + g.urunler.length; }, 0);
    kap.innerHTML = gruplar.map(function (g) {
      return '<section class="dz-urun-grup">' +
        '<h4 class="dz-urun-grup-baslik">' + kacir(g.ad) +
          '<span class="dz-urun-grup-adet">' + g.urunler.length + " ürün</span></h4>" +
        '<div class="dz-urunler-izgara">' + g.urunler.map(urunKarti).join("") + "</div>" +
      "</section>";
    }).join("") +
    '<p class="dz-urun-toplam">Sana eşleşen <b>' + toplam + " ürün</b> listelendi. " +
      '<a href="/collections/all">Tüm koleksiyonu gör →</a></p>';

    Array.prototype.forEach.call(kap.querySelectorAll(".dz-btn-sepet"), function (b) {
      b.addEventListener("click", function () { sepeteEkle(b); });
    });
  }

  function sepeteEkle(btn) {
    var varyant = btn.getAttribute("data-varyant");
    var eskiMetin = btn.textContent;
    btn.disabled = true;
    btn.textContent = "Ekleniyor…";

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(varyant), quantity: 1 }] }),
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || "Sepete eklenemedi"); });
        return r.json();
      })
      .then(function () {
        btn.textContent = "Sepette ✓";
        btn.classList.add("dz-eklendi");
        sepetSayisiTazele();
        sepetBildirim();
        setTimeout(function () { btn.disabled = false; btn.textContent = eskiMetin; btn.classList.remove("dz-eklendi"); }, 2600);
      })
      .catch(function (e) {
        btn.textContent = "Eklenemedi";
        console.warn("[deniz-test] sepet hatası:", e.message);
        setTimeout(function () { btn.disabled = false; btn.textContent = eskiMetin; }, 2600);
      });
  }

  // Temanın sepet rozetini günceller — tema yapısı bilinmediği için yaygın seçiciler denenir
  function sepetSayisiTazele() {
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var secici = ".cart-count-bubble span, .cart-count, [data-cart-count], .site-header__cart-indicator, .header__cart-count";
        Array.prototype.forEach.call(document.querySelectorAll(secici), function (n) {
          n.textContent = c.item_count;
          n.removeAttribute("hidden");
        });
        document.dispatchEvent(new CustomEvent("deniz:sepet-guncellendi", { detail: c }));
      })
      .catch(function () { /* rozet güncellenemezse akış bozulmaz */ });
  }

  function sepetBildirim() {
    var v = document.querySelector(".dz-bildirim");
    if (!v) {
      v = el("div", "dz-bildirim");
      v.innerHTML = '<span>Ürün sepetine eklendi</span><a href="/cart">Sepete git →</a>';
      document.body.appendChild(v);
    }
    v.classList.add("dz-gorunur");
    clearTimeout(v._z);
    v._z = setTimeout(function () { v.classList.remove("dz-gorunur"); }, 4200);
  }

  /* ---------- başlat ---------- */

  function baslat() {
    var kok = document.querySelector("[data-deniz-test]");
    if (!kok) return;
    K.kok = kok;

    var id = window.DENIZ_TEST_ID || kok.getAttribute("data-deniz-test");
    var testler = window.DENIZ_TESTLER || {};
    K.test = testler[id];

    if (!K.test) {
      kok.innerHTML = '<div class="dz-kart"><h2 class="dz-baslik-orta">Test bulunamadı</h2>' +
        '<p class="dz-ozet">“' + kacir(id) + '” kimliğinde bir test tanımlı değil.</p></div>';
      return;
    }

    kok.innerHTML =
      '<div class="dz-ilerleme"><div class="dz-ilerleme-dolgu"></div></div>' +
      '<div class="dz-sahne"></div>';
    kok.querySelector(".dz-sahne").appendChild(girisEkrani());

    if (window.DenizUzay && typeof window.DenizUzay.baslat === "function") {
      window.DenizUzay.baslat(kok);
    }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", baslat);
  else baslat();
})();
